const checkIfVariableTrue = (variable, defaultValue = false) => {
  if (variable === undefined || variable === null) {
    return defaultValue;
  }
  return variable === 'true' || variable === true;
};

export const Env = {
  server: {
    base: process.env.VUE_APP_BASE_URL,
    api: process.env.VUE_APP_API_BASE_URL || '/api',
    admin: process.env.VUE_APP_ADMIN_DOMAIN,
    mode: process.env.VUE_APP_SERVER_MODE || 'prod',
    broadcastHost: process.env.VUE_APP_BROADCAST_HOST,

    requestTimeout: parseInt(process.env.VUE_APP_REQUEST_TIMEOUT) || 20000,
  },
  features: {
    hideSearch: checkIfVariableTrue(process.env.VUE_APP_HIDE_SEARCH, true),
    showNetworkErrorMessages: checkIfVariableTrue(process.env.VUE_APP_SHOW_NETWORK_ERRORS, false),
  },
  trackers: {
    googleTrackerId: process.env.VUE_APP_GOOGLE_TRACKER_ID,
  },
  telegram: {
    botUsername: process.env.VUE_APP_TELEGRAM_BOT_USERNAME,
    agentsChannelUrl: process.env.VUE_APP_TELEGRAM_AGENTS_CHANNEL_URL,
  },
};
